/**
 * Const without params element
 * Form career component
 * Display form career and send via Netlify
 */

/* Import */
import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { navigate } from "gatsby-link"
import "../styles/common/netlifyform.scss"

/* Declaration */
const Formcareer = ( { param } ) => {
  const {t} = useTranslation()
  useStaticQuery(graphql`
    query {
      locales: allLocale(filter: {ns: {in: ["common"]}}) {
        edges {
          node {
            ns
            data
            language
          }
        }
      }
    }
  `)

  var defaultSubject = t('select-option1')
  if (param === "job-offer" || param === "offre-emploi") {
    defaultSubject = t('select-option1')
  }else if(param === "internship" || param === "stage") {
    defaultSubject = t('select-option2')
  }else if (param === "spontaneous" || param === "spontanee") {
    defaultSubject = t('select-option3')
  } else if (param === "team" || param === "equipe") {
    defaultSubject = t('select-option4')
  }

  const valueSelected = React.useRef(defaultSubject)
  const paramSelected = React.useRef(param)
  const [state, setState] = React.useState({subject: valueSelected.current})

  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value })
  }

  const handleChangeSelect = (e) => {
    setState({ ...state, [e.target.name]: e.target.value })
    valueSelected.current = e.target.value

    if(e.target.value === "Offre d'emploi") {
      paramSelected.current = "offre-emploi"
    }else if(e.target.value === "Job Offer") {
      paramSelected.current = "job-offer"
    }else if(e.target.value === "Stage") {
      paramSelected.current = "stage"
    }else if(e.target.value === "Internship") {
      paramSelected.current = "internship"
    }else if (e.target.value === "Candidature spontanée") {
      paramSelected.current = "spontanee"
    }else if (e.target.value === "Spontaneous Application") {
      paramSelected.current = "spontaneous"
    }else if (e.target.value === "Équipe") {
      paramSelected.current = "equipe"
    }else if (e.target.value === "Team") {
      paramSelected.current = "team"
    }
  }

  const handleAttachment = (e) => {
    setState({ ...state, [e.target.name]: e.target.files[0] })
  }


  const handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target

    fetch('/', {
      method: 'POST',
      body: encode({
        'form-name': form.getAttribute('name'),
        ...state,
      }),
    })
      .then(() => navigate(form.getAttribute('action')))
      .catch((error) => alert(error))
  }

  var linkAction = "/thank-you?job="+paramSelected.current


  return (
    <form
      name="myca-career"
      method="post"
      action={linkAction}
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      onSubmit={handleSubmit}
      className="netlify-form"
    >
      {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
      <input type="hidden" name="form-name" value="myca-career" />
      <p hidden>
        <label>
          Don’t fill this out: <input name="bot-field" onChange={handleChange} />
        </label>
      </p>
      <fieldset className="form-columns-2">
        <div className="ny-form-field">
          <label htmlFor="name">{t('name')}<span className="ny-form-required">*</span></label>
          <input className="ny-input" type="text" name="name" onChange={handleChange} required/>
        </div>
        <div className="ny-form-field">
          <label htmlFor="email">{t('email')}<span className="ny-form-required">*</span></label>
          <input className="ny-input" type="email" name="email" onChange={handleChange} required/>
        </div>
      </fieldset>
      <fieldset className="form-columns-1">
        <div className="ny-form-field field-file">
          <label htmlFor="cv">{t('cv')}<span className="ny-form-required">*</span></label>
          <input type="file" name="cv" className="btn-upload" onChange={handleAttachment} accept=".pdf, .doc, .docx" required/>
        </div>
      </fieldset>
      <fieldset className="form-columns-1">
        <div className="ny-form-field field-file">
          <label htmlFor="letter">{t('letter')}</label>
          <input type="file" name="letter" className="btn-upload" onChange={handleAttachment} accept=".pdf, .doc, .docx" />
        </div>
      </fieldset>

      <fieldset className="form-columns-1">
        <div className="ny-form-field">
          <label htmlFor="subject">{t('subject')}</label>
          <select id="subject" name="subject" className="ny-input" value={valueSelected.current} onChange={handleChangeSelect} >
            <option value={t('select-option1')} >{t('select-option1')}</option>
            <option value={t('select-option2')} >{t('select-option2')}</option>
            <option value={t('select-option3')} >{t('select-option3')}</option>
            <option value={t('select-option4')} >{t('select-option4')}</option>
          </select>
        </div>
      </fieldset>

      <fieldset className="form-columns-1">
        <div className="ny-form-field">
          <label>{t('message')}</label>
          <textarea className="ny-input" type="text" name="message" onChange={handleChange} />
        </div>
      </fieldset>

      <div className="ny-submit">
        <input className="ny-input" type="submit" name="submit" value={t('submit-job')} />
      </div>
    </form>
  )
}

/* Export */
export default Formcareer


function encode(data) {
  const formData = new FormData()

  for (const key of Object.keys(data)) {
    formData.append(key, data[key])
  }

  return formData
}